import {TextInput, useTranslationContext} from 'platform/components';
import {VStack} from 'platform/foundation';

import {isEmptyArray} from 'ramda-adjunct';

import {suffixTestId} from 'shared/web';

import {FILTER_VALUE_KEY} from '../../constants/filterValueKey';
import type {EagFilterProps} from '../../types/EagFilterProps';
import {getFilterFieldName} from '../../utils/getFilterFieldName';
import {getQuickFilterFromIntersection} from '../../utils/quickFilterValue';
import {QuickFilterChips} from '../QuickFilterChips/QuickFilterChips';

type TextFilterProps = EagFilterProps & {
  quickFilters?: Array<{value: string; label: string}>;
};

export function TextFilter(props: TextFilterProps) {
  const t = useTranslationContext();

  const model = (props.value[FILTER_VALUE_KEY] as string | null) ?? null;

  const onChange = (changeValue: string | null) => {
    props.onChange({[FILTER_VALUE_KEY]: changeValue});
  };

  const isQuickFilterValue = getQuickFilterFromIntersection(model);

  return (
    <VStack spacing={2}>
      <QuickFilterChips
        quickFilters={props.quickFilters}
        value={isQuickFilterValue}
        defaultValue={null}
        setFilterValue={onChange}
        isDisabled={props.isDisabled}
        data-testid={suffixTestId('text-filter-quickFilters', props)}
      />
      <TextInput
        placeholder={t('page.datagrid.filter.textPlaceholder', {
          field: getFilterFieldName(props.column),
        })}
        value={isEmptyArray(isQuickFilterValue) ? model : null}
        onChange={onChange}
        isDisabled={props.isDisabled}
        data-testid={suffixTestId('text-filter', props)}
      />
    </VStack>
  );
}
